import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldConfig } from '../../models/field.interface';
import 'fabric';

@Component({
  selector: 'app-free-form-draw',
  template: `
<div [formGroup]="group" *ngIf="field.style.visibility && !field.dynamic">
  <div class="hazard-description" [ngClass]="{'pointer-events' : !field.style.editability}">
    <p class="dynamic-paragraph">{{field.name}} <b *ngIf="field.validation.isRequired">*</b></p>
      <app-canvas [fieldId]="field.id" [backGroundImagePath]="this.field.data.image" [basedOnEditability]="field.style.editability" [svgPreviewPath]="field.value" (clear)="clear()"  (svgPath)="saveSvg($event)"></app-canvas>
      <span class="error-message" *ngIf="field.errorMessage !== ''">{{field.errorMessage}}</span>
  </div>
</div>
`,
  styles: []
})
export class FreeFormDrawComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;
  constructor() {}
  saveSvg($event) {
  
    this.field.value = {image: $event.image, thumbnail: $event.thumbnail};
  }
  clear(){
    this.field.value = undefined;
  }
  ngOnInit() {
  }
}


// WEBPACK FOOTER //
// ./src/app/rFF/fields/free-form-draw/free-form-draw.component.ts